import { render, staticRenderFns } from "./AnswerMedia.vue?vue&type=template&id=5e187a14&scoped=true"
import script from "./AnswerMedia.vue?vue&type=script&lang=js"
export * from "./AnswerMedia.vue?vue&type=script&lang=js"
import style0 from "./AnswerMedia.vue?vue&type=style&index=0&id=5e187a14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e187a14",
  null
  
)

export default component.exports